import React, { type JSX } from 'react';
import DeleteMutation from './DeleteAnalysMutation.gql';
import {
  DeleteAnalys,
  DeleteAnalysVariables,
} from './_QueryTypes/DeleteAnalys';
import { Mutation } from '@apollo/client/react/components';
import { MutationFunction as MutationFn } from '@apollo/client';
import AnalysListQuery from '../../../../../../Queries/EkonomiskAnalysListQuery/AnalysListQuery.gql';
import AnalysEgnaLokalaQuery from '../../Queries/AnalysEgnaLokalaQuery.gql';
import { EkonomiskAnalysContextConsumer } from '../../../../../Context/EkonomiskAnalysContext';
import ChangeStartAnalysMutation, {
  IStartAnalysInfo,
} from '../../../../EkonomiskAnalysSelect/Components/FavoriteAnalysDialog/Queries/ChangeStartAnalysMutation/ChangeStartAnalysMutation';
import { EkonomiskAnalysSelectConsumer } from '../../../AnalysSelect/Context/EkonomiskAnalysSelectContext';
import { ISelectedAnalys } from '../../../../../../EkonomiskAnalysPage';
import { ActiveDatabaseConsumer } from '../../../../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

export type DeleteAnalysFnType = (
  variables: DeleteAnalysVariables,
  dbname: string
) => () => void;

interface IProps {
  currentStartAnalys?: IStartAnalysInfo;
  deselectCurrentAnalys: boolean;
  selectedAnalys?: ISelectedAnalys | null;
  children: (deleteAnalys: DeleteAnalysFnType) => JSX.Element;
}

type saveAnalysMutationFnType = MutationFn<DeleteAnalys, DeleteAnalysVariables>;

class DeleteAnalysMutation extends React.Component<IProps> {
  deleteAnalys =
    (
      mutateFn: saveAnalysMutationFnType,
      codeSystemId: string,
      deselectAnalys: (ignoreStartAnalys: boolean) => void,
      changeStartAnalys: (startAnalys?: IStartAnalysInfo) => void,
      deselectCurrentAnalys: boolean | undefined,
      selectedAnalys: ISelectedAnalys | null | undefined,
      activeDatabase: string | null
    ) =>
    (variables: DeleteAnalysVariables, dbname: string) =>
    () => {
      mutateFn({
        variables: variables,
        refetchQueries: [
          {
            query: AnalysListQuery,
            variables: {
              codeSystemId,
              onlyFavorites: false,
              dbName: activeDatabase ?? '',
            },
          },
          {
            query: AnalysEgnaLokalaQuery,
            variables: { dbname: dbname, endast_anvandarens: true },
          },
        ],
      }).then(() => {
        if (
          deselectCurrentAnalys ||
          (selectedAnalys && selectedAnalys.analys.id === variables.id)
        ) {
          deselectAnalys(true);
        }
      });
      if (
        this.props.currentStartAnalys &&
        this.props.currentStartAnalys.rapportId === variables.id
      ) {
        changeStartAnalys();
      }
    };
  render() {
    return (
      <ActiveDatabaseConsumer>
        {({ activeDatabase }) => (
          <EkonomiskAnalysSelectConsumer>
            {({ deselectAnalys }) => (
              <EkonomiskAnalysContextConsumer>
                {({ codeSystemId }) => (
                  <ChangeStartAnalysMutation fullAnalysList={[]}>
                    {changeStartAnalys => (
                      <Mutation<DeleteAnalys, DeleteAnalysVariables>
                        mutation={DeleteMutation}
                      >
                        {deleteAnalysFn =>
                          this.props.children(
                            this.deleteAnalys(
                              deleteAnalysFn,
                              codeSystemId,
                              deselectAnalys,
                              changeStartAnalys,
                              this.props.deselectCurrentAnalys,
                              this.props.selectedAnalys,
                              activeDatabase
                            )
                          )
                        }
                      </Mutation>
                    )}
                  </ChangeStartAnalysMutation>
                )}
              </EkonomiskAnalysContextConsumer>
            )}
          </EkonomiskAnalysSelectConsumer>
        )}
      </ActiveDatabaseConsumer>
    );
  }
}

export default DeleteAnalysMutation;
